import { jsonFetch } from "@/lib/helpers";
import { Device } from "@/models";
import { DeviceDto } from "../devices/device-dto.model.api.services";
import { mapDeviceDTOToDevice } from "../devices/mappers";
import { getDevicesByRoomUrl } from "./api-url.constants";

export const getDevicesByRoom = async (roomId: string): Promise<Device[]> => {
  const response = await jsonFetch<{ data: DeviceDto[] }>(getDevicesByRoomUrl(roomId));
  return response.data.map(mapDeviceDTOToDevice);
};
